// extracted by mini-css-extract-plugin
export default {"box":"CodeBlock_box__ipts9"};